<template>
  <div v-if="authenticated" id="marketing">
    <section id="header-marketing" class="pb-0">
      <marketing-selection @selectedType="selectCampaignType"></marketing-selection>
    </section>

    <b-container id="content" class="mt-5">
      <div>
        <h2 v-if="1 === 2">{{ $t('account.professionalMarketingDescription') }}</h2>

        <div v-if="!selectedType && !selectedTraining">
          <h2>{{ $t('account.professionalMarketingDescription') }}</h2>
          <p>{{ $t('marketing.menuNotice') }}</p>
        </div>

        <div v-if="selectedType === 'boost'" class="higher-search-results">
          <boost-campaign :training="selectedTraining" :key="selectedTraining" @reset="reset"></boost-campaign>
        </div>

        <div v-if="selectedType === 'ads'" class="higher-search-results">
          <ads-campaign :training="selectedTraining" :key="selectedTraining" @reset="reset"></ads-campaign>
        </div>

        <div v-if="selectedType === 'affiliates'" class="higher-search-results">
          <ads-campaign :training="selectedTraining" :useAffiliates="true" :key="selectedTraining" @reset="reset"></ads-campaign>
        </div>

        <div v-if="selectedType === 'campaigns'">
          <marketing-campaigns :training="selectedTraining" :key="selectedTraining" @create="createCampaign" ref="campaigns"></marketing-campaigns>
        </div>
      </div>
    </b-container>
  </div>
  <div v-else>
    <b-alert variant="danger" show>
      {{ $t('account.accessDenied') }}
    </b-alert>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import { frontEndDateFormat } from '@/util/date'
  import { scrollTo } from '@/util/dom.js'

  /* Start of lazy load components config */
  import lazyLoadComponent from '@/util/lazy-load-component'
  import Preloader from '@/app/global/components/Preloader'
  // import SkeletonBox from '@/app/global/components/SkeletonBox'
  const lazyLoadOptions = {
    loading: Preloader,
    loadingData: {
      props: {
        width: '100%',
        height: '2rem'
      }
    }
  }
  /* End of lazy load components config */

  export default {
    name: 'account-marketing',
    components: {
      MarketingSelection: lazyLoadComponent({...lazyLoadOptions, componentFactory: () => import('./MarketingSelection')}),
      MarketingCampaigns: lazyLoadComponent({...lazyLoadOptions, componentFactory: () => import('./MarketingCampaigns')}),
      BoostCampaign: lazyLoadComponent({...lazyLoadOptions, componentFactory: () => import('./campaigns/Boost')}),
      AdsCampaign: lazyLoadComponent({...lazyLoadOptions, componentFactory: () => import('./campaigns/Ads')})
    },
    data () {
      return {
        errors: [],
        activeTab: 0,
        showTabsMobile: true,
        unsaved: false,
        selectedTraining: '',
        selectedType: ''
      }
    },
    // metaInfo: {
    //   title: 'Test',
    //   titleTemplate: '%s - Yay!',
    //   htmlAttrs: {
    //     lang: 'en',
    //     amp: true
    //   }
    // },
    computed: {
      ...mapGetters({
        user: 'account/user',
        authenticated: 'account/authenticated'
      }),
    },
    methods: {
      ...mapActions({
        getUserAdsCampaigns: 'account/getUserAdsCampaigns',
        getUserBoostCampaigns: 'account/getUserBoostCampaigns'
      }),
      frontEndDateFormat: frontEndDateFormat,
      scroll: scrollTo,
      scrollToContent: function () {
        let target = document.getElementById('content')
        if (target) {
          this.scroll(document.scrollingElement || document.documentElement, 'scrollTop', '', window.pageYOffset, target.offsetTop - 50, 300, true)
        }
      },
      changeTab (routerName) {
        this.$router.push({name: routerName})
        if (!this.unsaved) {
          this.tabsInit(routerName)
        }
      },
      disselectTab () {
        this.showTabsMobile = true
      },
      tabsInit (routerName) {
        this.showTabsMobile = true
        let parent = this
        switch (routerName) {
          case `MarketingCreate.${this.$i18n.i18next.language}`:
            this.activeTab = 0
            break
          case `MarketingCampaigns.${this.$i18n.i18next.language}`:
            this.activeTab = 1
            break
        }
      },
      createCampaign () {
        this.activeTab = 0
        this.selectedType = 'ads'
      },
      selectCampaignType (type, training) {
        this.selectedType = type
        this.selectedTraining = training
        this.scrollToContent()
      },
      reset () {
        this.selectedType = null
      }
    },
    mounted () {
      let payload = {
        training: this.trainingComp
      }
      this.getUserBoostCampaigns({ context: this, payload: payload })
      this.getUserAdsCampaigns({ context: this, payload: payload })
    },
    created () {
      this.tabsInit(this.$route.name)
    },
    watch: {
      // userLoadedSpecialities: function (newVal, oldVal) {
      //   this.userSpecialities = this.userLoadedSpecialities
      // },
      '$route' () {
        this.tabsInit(this.$route.name)
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  #header-marketing {
    position: relative;
    min-height: 350px;
    background: linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url(https://finefit.s3.eu-north-1.amazonaws.com/images/hero_home_new.jpg) no-repeat center center;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    overflow: visible;
    padding: 0;

    @include media-breakpoint-down(sm) {
      background: transparent;
      min-height: 500px;

      h2 {
        margin: 2rem 0;
        margin-bottom: 1rem;
      }

      .btn-cta {
        margin-bottom: 2rem;
      }
    }

    .container {
      position: relative;
      height: 350px;
    }

    @include media-breakpoint-down(sm) {

    }
  }

  #marketing {
    .nav-pills {
      min-width: 200px;

      li.nav-item {
        a.nav-link {
          color: #2c3e50;

          &.active {
            color: white !important;
            background: #f1a444;
          }
        }
      }
    }

    .tabs {
      .col-auto {
        @include media-breakpoint-down(sm) {
          display: none;
        }
      }

      .tab-pane {
        @include media-breakpoint-down(sm) {
          padding-left: 0;
          padding-right: 0;
        }
      }
    }

    .btn.mobile-tab {
      display: inline-block;
      color: black !important;
      font-weight: bold;
      white-space: normal;
      padding: 0.7rem 0.5rem;
      border: none;
      border-bottom: 2px solid black;
      border-radius: 0;
      text-align: left;
      box-shadow: none;
      background: transparent;

      i {
        margin-top: -3px;
        vertical-align: middle;
      }
    }

    .btn-back {
      position: relative;
      white-space: normal;

      i {
        position: absolute;
        left: 0.2rem;
        top: 50%;
        transform: translateY(-50%);
        margin-left: 0;
        margin-right: 0;
      }

      span {
        padding-left: 0.7rem;
        font-size: 0.8rem;
      }
    }
  }
</style>
